import {
  ArrowRightIcon,
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  IconButton,
  IconButtonSizeEnum,
  IconSizeEnum,
  PlusIcon,
  Typography,
} from '@acceso/design-system';

type TGeneralHeaderProps = {
  name: string;
  onClick?: () => void;
  onClose?: () => void;
  buttonName?: string;
  nameSize?: FontSizeEnum;
  secondName?: string;
  sectionNotice?: string;
};
export function GeneralHeader({
  name,
  nameSize,
  secondName,
  buttonName,
  onClick,
  onClose,
  sectionNotice,
}: TGeneralHeaderProps) {
  return (
    <div className="flex justify-between">
      <div className="flex items-center gap-2">
        {onClose && (
          <ArrowRightIcon onClick={onClose} className="cursor-pointer" size={IconSizeEnum.SM} />
        )}
        <Typography
          fontSize={nameSize || FontSizeEnum.Xl}
          weight={FontWeightEnum.Bold}
          color={FontColorEnum.Dark10}
        >
          {name}
          {secondName && ': '}
        </Typography>
        {secondName && (
          <Typography
            fontSize={nameSize || FontSizeEnum.Xl}
            weight={FontWeightEnum.Regular}
            color={FontColorEnum.Secondary}
          >
            {secondName}
          </Typography>
        )}
      </div>
      {sectionNotice && (
        <div className="flex items-center justify-end gap-2">
          <Typography
            fontSize={FontSizeEnum.Basic}
            weight={FontWeightEnum.Semibold}
            color={FontColorEnum.Error}
          >
            {sectionNotice}
          </Typography>
        </div>
      )}
      {onClick && buttonName && (
        <div className="flex items-center justify-end gap-2">
          <Typography
            fontSize={FontSizeEnum.Basic}
            weight={FontWeightEnum.Semibold}
            color={FontColorEnum.Dark10}
          >
            {buttonName}
          </Typography>

          <IconButton size={IconButtonSizeEnum.LG} onClick={onClick}>
            <PlusIcon size={IconSizeEnum.SM} />
          </IconButton>
        </div>
      )}
    </div>
  );
}
